export const selectCardsLibrary = (state) => {
  return state.cardsLibrary;
};

export const selectCardsLibraryMeta = (state) => {
  return selectCardsLibrary(state).meta;
};

export const selectCardsLibraryCards = (state) => {
  return selectCardsLibrary(state).cards;
};
